export default class Advert {
  constructor(data = {}) {
    // Attempt to read the advert
    if (!data.creative || !data.creative.length) {
      return false;
    }

    // Get the ID and creative data
    const adid = data.adid;
    const creative = data.creative[0];

    // Set the media source and click
    this.src = this.find(creative, 'file');
    this.href = creative.tracking.click;
    this.title = this.find(creative, 'title');

    // If it's a noclick, remove the link
    if (this.contains(creative, 'noclick')) {
      this.href = false;
    }

    // Should we pause/resume on visibility change?
    this.visibility = this.contains(creative, 'visibility');

    // Get the impressions and vast trackers
    this.meta = {
      id: adid,
      vast: this.findAll(creative, 'vast'),
      scripts: this.findAll(creative, 'javascript'),
      analytics: this.findRemoteScripts(data).concat(
        this.findAll(creative, 'analytics')
      ),
      impressions: [
        creative.tracking.impression,
        ...this.findAll(creative, 'impression3rdparty'),
      ],
      position: data.position,
    };
  }

  // Check if it contains <field />
  contains(data, field) {
    const regexp = new RegExp(`<${field}(\\s*?/)?>`, 'im');
    const matches = data.media.match(regexp);
    if (!matches || !matches.length) {
      return false;
    }
    return true;
  }

  // Find the value for <field>this</field>
  find(data, field, defaultValue = false) {
    const regexp = new RegExp(`<${field}>\\s*(.*?)\\s*</${field}>`, 'im');
    const matches = data.media.match(regexp);
    if (!matches || !matches.length) {
      return defaultValue;
    }
    return matches[1];
  }

  // Get all <field>values</field>
  findAll(data, field) {
    const regexp = new RegExp(`<${field}>\\s*(.*?)\\s*</${field}>`, 'gim');
    let match = regexp.exec(data.media);
    const result = [];
    while (match) {
      result.push(match[1]);
      match = regexp.exec(data.media);
    }

    return result;
  }

  // Get all <script src=""> elements (basically to simulate our analytics block)
  // because apparently MOAT has OpenX injection built-in that works like this.
  findRemoteScripts(data) {
    const regexp = /<script[^>]*>/gim;
    let match = regexp.exec(data.html);
    const result = [];
    while (match) {
      if (match[0].match(/src=(['"])*https:\/\//)) {
        result.push(`${match[0]}</script>`);
      }
      match = regexp.exec(data.html);
    }

    return result;
  }
}
